import type { SVGProps } from 'react';
const DawnFlagKG = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    fill="none"
    viewBox="0 0 22 16"
    {...props}
  >
    <rect width={22} height={16} fill="#fff" rx={2} />
    <mask
      id="dawn-flag-KG_svg__a"
      width={22}
      height={16}
      x={0}
      y={0}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: 'luminance',
      }}
    >
      <rect width={22} height={16} fill="#fff" rx={2} />
    </mask>
    <g mask="url(#dawn-flag-KG_svg__a)">
      <path fill="#F22A46" d="M0 0h22v16H0z" />
      <path
        fill="#FFF04D"
        fillRule="evenodd"
        d="M11 10.667c1.446 0 2.619-1.194 2.619-2.667s-1.173-2.667-2.62-2.667C9.554 5.333 8.382 6.527 8.382 8S9.553 10.667 11 10.667"
        clipRule="evenodd"
      />
      <path
        fill="#FFF04D"
        fillRule="evenodd"
        d="M9.718 13.72 11 11.77l1.282 1.949.325-2.322 1.986 1.189-.697-2.236 2.296.194L14.61 8.84 16.762 8l-2.151-.839 1.58-1.706-2.295.194.697-2.236-1.986 1.19-.325-2.322L11 4.229 9.718 2.281l-.325 2.322-1.985-1.19.697 2.236-2.296-.194 1.58 1.706-2.15.84 2.15.838-1.58 1.707 2.296-.195-.697 2.236 1.985-1.19zM14.667 8c0 2.062-1.642 3.733-3.667 3.733S7.334 10.062 7.334 8 8.975 4.267 11 4.267 14.667 5.938 14.667 8"
        clipRule="evenodd"
      />
    </g>
  </svg>
);
export default DawnFlagKG;
